import { render, staticRenderFns } from "./cargo_item_2.vue?vue&type=template&id=0789c20e&scoped=true&"
import script from "./cargo_item_2.vue?vue&type=script&lang=js&"
export * from "./cargo_item_2.vue?vue&type=script&lang=js&"
import style0 from "./cargo_item_2.vue?vue&type=style&index=0&id=0789c20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0789c20e",
  null
  
)

export default component.exports